import styles from './Button.module.scss';

interface ButtonProps {
    text: string;
    size: 'small' | 'medium';
    type: 'cta' | 'primary' | 'secondary';
    width?: 'auto';
    disabled?: boolean;
    selected?: boolean;
    onClick: () => void;
}

export const Button = (props: ButtonProps): React.ReactElement => {
    const classes = [
        styles.btn,
        styles[props.size],
        styles[props.type],
        props.width ? styles[props.width] : '',
        props.selected ? styles['selected'] : ''
    ].join(' ')
 
    return (
        <button className={classes} disabled={props.disabled} onClick={props.onClick}>
            {props.text}
        </button>
    );
}

Button.defaultProps = {
    size: "medium",
};